/*
 * @Author: zwt.daffy
 * @Date: 2019-08-05 10:01:20
 * @Last Modified by:   zwt.daffy
 * @Last Modified time: 2019-08-05 10:01:20
 * 机构相关接口
 */
import request from '@/api/base'

// 下载机构模板
const downloadOrganTemplate = () => {
  return request.get('/ipark-admin/aloneUm/org/downloadTemplate', { responseType: 'blob' })
}

// 导出机构列表
const exportOrganList = () => {
  return request.get('/ipark-admin/aloneUm/org/exportOrgList', { responseType: 'blob' })
}

// 批量导入机构
const importOrganList = (params) => {
  return request.post('/ipark-admin/aloneUm/org/importOrgList', params, { 'Content-Type': 'multipart/form-data' })
}

// 查看导入结果
const downloadImportResult = (params) => {
  return request.get('/ipark-admin/aloneUm/org/downloadImportResult', {params, responseType: 'blob'})
}

// 加载机构树
const queryAllOrgan = (params) => {
  return request.post('/ipark-admin/aloneUm/org/queryAllOrgAsTree', params)
}

// 新增机构
const addOrgan = (params) => {
  return request.post('/ipark-admin/aloneUm/org/addOrg', params)
}

// 判断是否可删除机构
const checkDelOrgan = (params) => {
  return request.post('/ipark-admin/aloneUm/org/checkDelByOrgId', params)
}

// 删除机构
const delOrgan = (params) => {
  return request.post('/ipark-admin/aloneUm/org/delOrgByOrgId', params)
}

// 修改机构
const editOrgan = (params) => {
  return request.post('/ipark-admin/aloneUm/org/editOrgInfo', params)
}

// 修改机构
const isOrgNameExist = (params) => {
  return request.post('/ipark-admin/aloneUm/org/isOrgNameExist', params)
}

// 排序机构
const sortOrgan = (params) => {
  // return Promise.resolve({code: 200})
  return request.post('/ipark-admin/aloneUm/org/sortOrgs', params)
}

// 排序机构
const queryAllOrgList = (params) => {
  return request.post('/ipark-admin/aloneUm/org/queryAllOrg', params)
}

// 按条件搜索用户
const searchUserByCondition = (params) => {
  return request.post('/ipark-admin/aloneUm/user/queryUsersBySystemBook', params)
}
// const searchUserByCondition = (params) => {
//   return request.post('/ipark-admin/aloneUm/user/queryUsersByCondition', params)
// }

// 交换排序
const switchRank = (params) => {
  return request.post('/ipark-admin/aloneUm/user/changeRelativeUserRanks', params)
}

// 交换排序
const updateRank = (params) => {
  return request.post('/ipark-admin/aloneUm/user/updateUserBookRank', params)
}

// 获取所有职级
const queryUserGrade = (params) => {
  return request.post('/ipark-admin/aloneUm/user/queryUserGrade', params)
}
// 获取所有职级
const querySelectRoleRule = (params) => {
  return request.post('/ipark-admin/holiday/querySelectRoleRule', params)
}

// 获取机构负责人还是主要负责人列表
const queryOrgChargeList = (params) => {
  return request.post('/ipark-admin/aloneUm/user/queryOrgChargeList', params)
}

const getOrganList = (params) => {
  return Promise.resolve({body: []})
}

export default {
  downloadOrganTemplate,
  exportOrganList,
  importOrganList,
  downloadImportResult,
  addOrgan,
  checkDelOrgan,
  delOrgan,
  editOrgan,
  isOrgNameExist,
  queryAllOrgan,
  sortOrgan,
  queryAllOrgList,
  querySelectRoleRule,
  searchUserByCondition,
  switchRank,
  updateRank,
  queryUserGrade,
  getOrganList,
  queryOrgChargeList
}



// WEBPACK FOOTER //
// ./src/area-common/api/organService.js